import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IItems } from '../form.interface';

/**
 * 获取picture-model需要置灰的设置项。
 * @param model 所选元素
 * @returns
 */
export const getImageDisabledItems = (model: IPictureModel): IItems => {
    const isImage = model.isImage();
    return {
        // 幻灯片相对图片原始尺寸
        [FormItemName.RELATIVE_IMAGE_ORIGINAL_SIZE]: () => !isImage,
        // 幻灯片最佳放映比例
        [FormItemName.BEST_PLAY_SCALE]: () => !isImage,
    };
};
